import { memo } from 'react';
import { Skeleton } from '@bonanza-social/moonlight';

function PrizeWallInfoQuickRulesSkeleton() {
  return Array.from({ length: 3 }, (_, index) => (
    <Skeleton
      key={index}
      borderRadius="radius-400"
      backgroundColor="primaryBackgroundHover"
      height={110}
    />
  ));
}

export default memo(PrizeWallInfoQuickRulesSkeleton);
